import { Box, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { formatarMonetárioParaNúmero } from "../../../../../../../../helpers/masks";
import PagamentoParcelado, { TParcela } from "./PagamentoParcelado";
import { useCallback } from "react";

interface Step03Props {
    valorTotal: number;
}

export default function Step03({ valorTotal }: Step03Props) {
    const { setValue, watch } = useFormContext();
    const parcelamento = watch("parcelamento");

    const handleParcelasChange = useCallback((newParcelas: TParcela[]) => {
        setValue("parcelamento.parcelas", newParcelas, { shouldValidate: false });
        setValue(
            "parcelamento.valores",
            newParcelas.map(p => {
                return formatarMonetárioParaNúmero(p.valor_parcela)
            }),
            { shouldValidate: false }
        );
        setValue(
            "parcelamento.vencimentos",
            newParcelas.map(p => p.data_vencimento.format("YYYY-MM-DD")),
            { shouldValidate: false }
        );
    }, [setValue]);

    const handleFormaPrimeiraParcelaChange = useCallback((forma: 'personalizada' | 'dias_corridos', diasCorridos?: string) => {
        setValue("parcelamento.forma_primeira_parcela", forma, { shouldValidate: false });
        if (diasCorridos) {
            setValue("parcelamento.dias_corridos_primeira_parcela", diasCorridos, { shouldValidate: false });
        }
    }, [setValue]);

    const handleValorPrimeiraParcelaChange = useCallback((valor: number | null) => {
        setValue("parcelamento.valor_primeira_parcela_customizado", valor, { shouldValidate: false });
    }, [setValue]);

    return (
        <Box p={4} maxWidth={600} mx="auto">
            <Typography variant="h5" fontWeight={700} mb={3}>
                Pagamento da Ordem de Compra
            </Typography>
            <PagamentoParcelado
                valorTotal={valorTotal}
                parcelas={parcelamento.parcelas}
                habilitarSelecaoPrimeiraParcela={true}
                onChange={handleParcelasChange}
                onFormaPrimeiraParcelaChange={handleFormaPrimeiraParcelaChange}
                onValorPrimeiraParcelaChange={handleValorPrimeiraParcelaChange}
                valorPrimeiraParcelaInicial={parcelamento.valor_primeira_parcela_customizado}
            />
        </Box>
    );
}
